import styled from '@emotion/styled';

const Foot = styled.tfoot`
  transition: ${p => p.theme.colorModeTransition};
`;

export default Foot;
